<div
	#mapContainer
	id="map"></div>
<div class="global-map-network-legend">
	<div class="legend-scale">
		<ul class="legend-labels">
			<li><span style="border-top: 6px solid #000000"></span>Cell C</li>
			<li><span style="border-top: 6px solid #f3db00"></span>MTN</li>
			<li><span style="border-top: 6px solid #166bce"></span>Telkom</li>
			<li><span style="border-top: 6px solid #eb1900"></span>Vodacom</li>
			<li><span style="border-top: 6px solid #666666"></span>Other</li>
		</ul>
	</div>
</div>
<app-chip-filter
	id="chip-filter"
	style="padding-top: 5px; width: 100%"
	[filterOptions]="filterOptions"
	[filterChips]="filterChips"
	(searchSubmit)="searchSubmit($event)"
	(filtersToggled)="filterToggled()"
	(filtersCleared)="filtersCleared()"
	(searchValueChanged)="searchValueChanged()">
</app-chip-filter>
@if (maploading == true) {
<div
	class="spin"
>
	<mat-spinner
		class="map-spinner"
		name="bubbles"></mat-spinner>
</div>
}

<div id="map-type-control">
	<div class="map-controls">
		<mat-list>
			<h3 style="font-size: 13pt; font-weight: bold">Map Options</h3>
			<mat-list-item lines="none">
				<mat-checkbox
					[disabled]="deviceMapData.length == 0"
					checked
					(ionChange)="toggleDeviceCluster()"
					color="dark"
					slot="start"></mat-checkbox>
				<mat-label>Show Clusters</mat-label>
			</mat-list-item>
		</mat-list>
		<div class="row">
			<div class="column left-col">
				@if (lastRefresh != null) {
<div
				
					style="margin-top: 10px">
					Last Refresh:
				</div>
}
				<div> {{lastRefresh}} </div>
			</div>
			<div class="column right-col">
				<button
					mat-icon-button
					(click)="setMapRefresh(150)"
					><mat-icon>refresh</mat-icon></button
				>
			</div>
		</div>
	</div>
</div>
